<template>
  <div class="insidelands--template">
    <h1 class="absolute mv0 tc h1 w1 transparent" style="color: transparent;">{{ page.title }}</h1>
    <div class="relative container-fluid pt4 pb5 pt5-ns pb6-ns">
      <section class="db relative center mw7" :id="page.intro_section.id" v-if="page.intro_section && page.intro_section.is_published">
        <img class="db relative center mw7" v-if="page.logo_lockup_image" :src="page.logo_lockup_image" alt="Inside Lands : Aug 28-29 2020 - Presented By Outside Lands" />
        <h2 class="mt5 tc ttu f2 f2-ns is-lorano-bold is-green" v-if="page.intro_section.header">{{page.intro_section.header}}</h2>
        <div class="relative mt4 f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.intro_section.text)"></div>
        <img class="db relative center w-100 mt4 mw6" v-lazy="page.intro_section.twitch.image" />
        <div class="mt4 tc ttn f3 f2-ns is-tablet-semicond-bold lh-copy is-green" v-if="page.intro_section.twitch.text" v-html="page.intro_section.twitch.text"></div>
        <div class="dn relative center w-100 mw6">
          <h4 class="absolute mv0 tc h1 w1 transparent" style="color: transparent;">Exclusively On Twitch</h4>
        </div>
      </section>
      <section :id="page.schedule_section.id" class="db relative center mw8 pv3" v-if="page.schedule_section && page.schedule_section.is_published">
        <h2 class="mt5 tc ttu f-4 f-4-ns is-blenny is-red" v-if="page.schedule_section.title">{{ page.schedule_section.title }}</h2>
        <div class="row mt3">
          <div class="col-xs-12 col-md-6 mv4 mv3-ns" v-for="(item, index) in page.schedule_section.schedules" :key="'schedule-' + scheduleDay(index)">
            <h3 class="mb2 tc ttu f1 is-blenny is-red" >{{ scheduleDay(index) }}</h3>
            <a class="db relative pointer mt2 mt3-ns grow ph0 ph2-ns" :href="item.link" target="_blank" :title="item.title + ' Schedule'">
              <img class="" v-lazy="item.image" :title="item.title" />
            </a>
          </div>
        </div>
        <div class="mt4 tc ttn f3 is-tablet-semicond-bold lh-copy is-green" v-if="page.schedule_section && page.schedule_section.text" v-html="marked(page.schedule_section.text)"> </div>
      </section>
      <section :id="page.lineup_section.id" class="db relative center mw7 pv3" v-if="page.lineup_section && page.lineup_section.is_published">
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.lineup_section.title">{{ page.lineup_section.title }}</h2>
        <div class="row mt3 mt4-ns">
          <div class="col-xs-12 col-sm-12 mv2 mv3-ns">
            <a class="db relative pointer grow" :href="page.lineup_section.link" target="_blank" :title="page.lineup_section.title">
              <img class="" v-lazy="page.lineup_section.image" :title="page.lineup_section.title" :alt="page.lineup_section.title" />
            </a>
          </div>
        </div>
      </section>
      <section :id="page.watch_section.id" class="db relative center mw8 pv3" v-if="page.watch_section && page.watch_section.is_published">
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.lineup_section.title">{{ page.watch_section.title }}</h2>
        <router-link class="db relative mt4 tc ttn f3 f2-ns is-tablet-semicond-bold lh-copy is-red pointer grow" to="/outside-lands-works/" title="Donations will benefit Outside Lands Works">
          Donations will benefit Outside Lands Works
        </router-link>
        <div class="db relative center mw8 mt4 pb3">
          <div id="twitch-embed-container" ref="twitchEmbedContainer" class="db relative center w-100" v-if="page.intro_section.twitch_embed && page.intro_section.twitch_embed.is_published"></div>
        </div>
      </section>
      <section :id="page.merch_section.id" class="db relative center mw7 pv3" v-if="page.merch_section && page.merch_section.is_published">
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.merch_section.title">{{page.merch_section.title}}</h2>
        <div class="row middle-sm mt0 mt4-ns">
          <div class="col-xs-12 col-sm-6 ph0 pr3-ns">
            <img class="db relative center mt4 w-100 mw7 il-img-border" :src="page.merch_section.image" />
          </div>
          <div class="col-xs-12 col-sm-6 ph0 pl3-ns">
            <a class="flex relative center w-100 mw6-ns justify-center tc overflow-hidden f3 ttu pointer mt4 btn-green" :href="page.merch_section.cta_button.link" :title="page.merch_section.cta_button.link" target="_blank">
              <span class="text">{{ page.merch_section.cta_button.title}}</span>
            </a>
            <div class="db relative mt3 f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.merch_section.text)"></div>
          </div>
        </div>
      </section>
      <section :id="page.news_section.id" class="db relative center mw8 pv3" v-if="page.news_section && page.news_section.is_published" >
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.news_section.title">{{ page.news_section.title }}</h2>
        <div class="row mt4">
          <div class="col-xs-12 col-sm-6 mv4 mv3-ns ph0 ph3-ns" v-for="(item, index) in page.news_section.posts" :key="'news-post-'+ index">
            <a class="db relative pointer grow" :href="item.link" :title="item.title" v-if="item.is_link_out === true" target="_blank">
              <div class="db relative bg-center-top news-zoom aspect-ratio--16x9 cover il-img-border" v-lazy:background="item.image"></div> 
              <h3 class="mt2 f3 lh-copy tc is-tablet-semicond-bold ttu is-green">{{item.title}}</h3>
              <div class="mt2 f4 lh-copy tc is-tablet-semicond-bold is-green" v-if="item.text" v-html="marked(item.text)">{{item.text}}</div>
            </a>
            <router-link class="db relative center pointer grow" :to="item.link" :title="item.title" v-else>
              <div class="db relative bg-center-top news-zoom aspect-ratio--16x9 cover il-img-border" v-lazy:background="item.image"></div> 
              <h3 class="mt2 f3 lh-copy tc is-tablet-semicond-bold ttu is-green">{{item.title}}</h3>
              <div class="mt2 f4 lh-copy tc is-tablet-semicond-bold is-green" v-if="item.text" v-html="marked(item.text)">{{item.text}}</div>
            </router-link>
          </div>
        </div>
      </section>
      <section :id="page.partners_section.id" class="db relative center mw8 pv3" v-if="page.partners_section && page.partners_section.is_published" >
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.partners_section.title">{{ page.partners_section.title }}</h2>
        <div class="row middle-sm mt4">
          <div class="col-xs-6 col-sm-2 center mv2 mv3-ns" v-for="(item, index) in page.partners_section.partner_images" :key="'partner-image-'+ index" v-if="item && item.is_published">
            <a class="db relative pointer grow" :href="item.link" target="_blank">
              <div class="db relative bg-center-top aspect-ratio--1x1 bg-white il-img-border">
                <img class="db absolute center abs-vert-center w-100 mw100 ph2" v-lazy="item.image" :alt="item.title" />
              </div> 
            </a>
          </div>
        </div>
        <!-- <BgVimeoVideoEmbed class="mt4" v-if="page.partners_section.video.vid_id && page.partners_section.video.is_published" :vimeoVideoId="page.partners_section.video.vid_id"/> -->
      </section>
      <section id="ol-works" class="db relative center mw8 pt5 pt6-ns">
        <div class="plg-donate" data-widget-id="xsZJ7T2BtWPZdsf0VZa1tg"></div>
      </section>


      <!--
      <section :id="page.share_section.id" class="db relative center mw7 pv3" v-if="page.share_section && page.share_section.is_published">
        <h2 class="mt5 tc ttu f1 f-4-ns is-blenny is-red" v-if="page.share_section.title">{{page.share_section.title}}</h2>
        <div class="row middle-sm mt0 mt4-ns">
          <div class="col-xs-12 col-sm-6 ph0 pr3-ns">
            <div class="db relative mt4 mt0-ns f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.share_section.block_1_text)"></div>
            <div class="dn db-ns relative mt4 f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.share_section.block_2_text)"></div>
            <div class="dn db-ns relative mt4 f3 lh-copy tc is-tablet-semicond-regular is-green" v-html="marked(page.share_section.block_3_text)"></div>
          </div>
          <div class="col-xs-12 col-sm-6 ph0 pl3-ns">
            <img class="db dn-ns relative center mt4 w-100 mw7 il-img-border" v-if="page.share_section.image" :src="page.share_section.image" />
            <div v-if="page.logo_lockup_image" class="dn db-ns bg-center-top aspect-ratio--1x1 il-img-border" v-lazy:background="page.share_section.image"></div> 
            <img v-else class="db dn-ns relative center mt4 mw7 il-img-border" :src="page.share_section.image" />  
            <a class="dn flex-ns relative center w-100 mw6-ns justify-center tc overflow-hidden f3 ttu pointer mt4 btn-green" :href="page.share_section.cta_button.link" :title="page.share_section.cta_button.link" target="_blank">
              <span class="text">{{ page.share_section.cta_button.title}}</span>
            </a>
          </div>
        </div>
        <div class="db dn-ns relative mt4 f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.share_section.block_2_text)"></div>
        <div class="db dn-ns relative mt3 f3 lh-copy tc is-tablet-semicond-bold is-green" v-html="marked(page.share_section.block_3_text)"></div>
        <a class="flex dn-ns relative center w-100 mw6-ns justify-center tc overflow-hidden f3 ttu pointer mt5 btn-green" :href="page.share_section.cta_button.link" :title="page.share_section.cta_button.link" target="_blank">
          <span class="text">{{ page.share_section.cta_button.title}}</span>
        </a>
      </section>
      -->
    </div>
  </div>
</template>

<script>
//import BgVimeoVideoEmbed from './bg-vimeo-video-embed.vue';
export default {
  components: {
    //BgVimeoVideoEmbed
    //'cta-footer': () => import('./cta-footer.vue')
  },
  props: ['id','pageMarkdownFileName'],
  metaInfo () {
    return {
      title: this.page.seo_title,
      titleTemplate: (titleChunk) => {
        return titleChunk ? `${titleChunk}` : '';
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.page.seo_description }
      ]
    }
  },
  data () {
    return {
      logoIsLoaded: false,
      isWindowWidthMobile: false,
    }
  },
  computed: {
    page: function () {
      var pageData = this.$store.getters.filterPagesByName('insidelands.markdown');
      return pageData[0];
    }
  },
  methods: {
    scheduleDay: function(index) {
      const i = index;
      return i === 0 ? 'Friday' : 'Saturday'
    }
  },
  created() {
    /* Twitch embed script embed - NOT USING */
    /*let twitchScript = document.createElement('script');   
    twitchScript.setAttribute('id', 'twitch-script') 
    twitchScript.setAttribute('src','https://embed.twitch.tv/embed/v1.js');
    document.body.appendChild(twitchScript);*/
  },
  mounted() {
    var w = window.innerWidth;
    /* Hash Anchor Link functionality */
    if (this.$route.hash) {
      setTimeout(() => {
        var anchorId = this.$route.hash;
        var element = anchorId.replace('#','');
        document.getElementById(element).scrollIntoView({ block: 'start',  behavior: 'smooth' });
      }, 300)
    }
    this.$nextTick(() => {
      //
    });

    const twitchEmbedElem = document.createElement("div")
    twitchEmbedElem.setAttribute("id", "twitch-embed");
    
    this.$refs.twitchEmbedContainer.appendChild(twitchEmbedElem);
    /* Init Twitch Embed */
    new Twitch.Embed("twitch-embed", {
      //width: 854,
      width: '100%',
      height: 480,
      channel: "sfoutsidelands",
      allowfullscreen: true,
      theme: 'dark',
      // only needed if your site is also embedded on embed.example.com and othersite.example.com 
      parent: ["embed.example.com", "othersite.example.com"]
    });
  },
  destroyed() {
    const twitchEmbedDiv  = document.getElementById('twitch-embed');
    twitchEmbedDiv.remove();
  }
}
</script>
